import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  Save,
  Trash2,
  Edit3,
  Plus,
  FileText,
  Users,
  CheckCircle,
  XCircle,
  Loader2,
  Send,
  Info,
} from "lucide-react";

export default function KelolaKuis() {
  const [activeTab, setActiveTab] = useState("bank");
  const [loading, setLoading] = useState(true);

  // DATA
  const [kuisList, setKuisList] = useState([]);
  const [siswaList, setSiswaList] = useState([]);
  const [mapelList, setMapelList] = useState([]);

  // INFO USER
  const [currentUser, setCurrentUser] = useState(null);

  // FORM KUIS
  const [formKuis, setFormKuis] = useState({
    judul: "",
    link_url: "",
    mapel: "",
    pembuat: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  // FORM ASSIGN
  const [assignData, setAssignData] = useState({ kuis_id: "", siswa_id: "" });

  // NOTIFIKASI
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });

  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem("ruangKelasUser"));
    if (savedUser) {
      setCurrentUser(savedUser);
      fetchData(savedUser);
    }
  }, []);

  const showToast = (message, type = "success") => {
    setNotification({ show: true, message, type });
    setTimeout(
      () => setNotification((prev) => ({ ...prev, show: false })),
      3000
    );
  };

  // --- 1. LOGIKA FETCH DATA ---
  async function fetchData(user) {
    setLoading(true);
    let listSiswaFinal = [];

    try {
      // A. LOGIKA PENGAMBILAN SISWA
      if (user.role === "tutor") {
        const { data: dataAkun } = await supabase
          .from("akun")
          .select("id")
          .eq("username", user.username)
          .single();
        if (!dataAkun)
          throw new Error("Akun login tidak ditemukan di database.");

        const { data: dataTutor } = await supabase
          .from("tutor")
          .select("id")
          .eq("akun_id", dataAkun.id)
          .single();

        if (!dataTutor) {
          console.warn("Profil Tutor belum terhubung.");
        } else {
          const { data: relasi } = await supabase
            .from("relasi_siswa_tutor")
            .select("siswa(id, nama_lengkap, kelas)")
            .eq("tutor_id", dataTutor.id);

          listSiswaFinal = relasi?.map((r) => r.siswa) || [];
        }
      } else {
        const { data } = await supabase
          .from("siswa")
          .select("*")
          .order("nama_lengkap");
        listSiswaFinal = data || [];
      }

      setSiswaList(listSiswaFinal);

      // B. AMBIL DATA LAIN
      const { data: mp } = await supabase
        .from("mata_pelajaran")
        .select("*")
        .order("nama_mapel");
      setMapelList(mp || []);

      const { data: kuis } = await supabase
        .from("kuis")
        .select("*")
        .order("created_at", { ascending: false });
      setKuisList(kuis || []);
    } catch (err) {
      console.error("Error Fetching:", err);
      showToast("Gagal memuat data: " + err.message, "error");
    } finally {
      setLoading(false);
    }
  }

  // --- 2. CRUD KUIS (BANK SOAL) ---
  async function handleSimpanKuis(e) {
    e.preventDefault();
    if (!formKuis.judul || !formKuis.link_url)
      return showToast("Judul dan Link wajib diisi!", "error");

    try {
      const payload = {
        judul: formKuis.judul,
        link_url: formKuis.link_url,
        mapel: formKuis.mapel,
        pembuat: currentUser?.nama || "Admin",
      };

      if (isEditing) {
        const { error } = await supabase
          .from("kuis")
          .update(payload)
          .eq("id", editId);
        if (error) throw error;
        showToast("Kuis berhasil diupdate!", "success");
      } else {
        const { error } = await supabase.from("kuis").insert([payload]);
        if (error) throw error;
        showToast("Kuis baru berhasil dibuat!", "success");
      }

      setFormKuis({ judul: "", link_url: "", mapel: "", pembuat: "" });
      setIsEditing(false);
      fetchData(currentUser);
    } catch (error) {
      showToast("Gagal simpan: " + error.message, "error");
    }
  }

  async function handleDeleteKuis(id) {
    if (!confirm("Hapus kuis ini?")) return;
    const { error } = await supabase.from("kuis").delete().eq("id", id);
    if (error) showToast("Gagal hapus.", "error");
    else {
      showToast("Kuis dihapus.", "success");
      fetchData(currentUser);
    }
  }

  function handleEditKuis(item) {
    setFormKuis({
      judul: item.judul,
      link_url: item.link_url,
      mapel: item.mapel,
      pembuat: item.pembuat,
    });
    setIsEditing(true);
    setEditId(item.id);
    setActiveTab("bank");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // --- 3. ASSIGN KUIS (PERBAIKAN: HAPUS KOLOM NILAI) ---
  async function handleAssign(e) {
    e.preventDefault();
    if (!assignData.kuis_id || !assignData.siswa_id)
      return showToast("Pilih Kuis dan Siswa dulu!", "error");

    try {
      // Cek Duplikasi
      const { data: existing } = await supabase
        .from("kuis_siswa")
        .select("*")
        .eq("kuis_id", assignData.kuis_id)
        .eq("siswa_id", assignData.siswa_id)
        .single();

      if (existing) {
        showToast("Siswa ini sudah mendapatkan tugas kuis tersebut.", "error");
        return;
      }

      // PERBAIKAN DI SINI: Hapus 'nilai: 0' karena kolomnya tidak ada di database
      const { error } = await supabase.from("kuis_siswa").insert([
        {
          kuis_id: assignData.kuis_id,
          siswa_id: assignData.siswa_id,
          status: "Belum", // Sesuaikan dengan data di screenshot Anda ("Belum")
        },
      ]);

      if (error) throw error;
      showToast("Berhasil mengirim kuis ke siswa!", "success");
      setAssignData({ ...assignData, siswa_id: "" });
    } catch (error) {
      showToast("Gagal menugaskan: " + error.message, "error");
    }
  }

  if (loading)
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader2 className="animate-spin" size={40} color="#2563eb" />
      </div>
    );

  // STYLES
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "sans-serif",
    background: "#f8fafc",
    minHeight: "100vh",
  };
  const toastStyle = {
    position: "fixed",
    left: "50%",
    transform: "translateX(-50%)",
    top: notification.show ? "30px" : "-80px",
    opacity: notification.show ? 1 : 0,
    background: "white",
    padding: "12px 24px",
    borderRadius: "50px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    zIndex: 9999,
    border:
      notification.type === "success"
        ? "1px solid #dcfce7"
        : "1px solid #fee2e2",
    transition: "all 0.4s",
  };
  const tabBtnStyle = (isActive) => ({
    flex: 1,
    padding: "12px",
    border: "none",
    background: isActive ? "#2563eb" : "#e2e8f0",
    color: isActive ? "white" : "#64748b",
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: "8px",
    transition: "0.2s",
  });

  return (
    <div style={containerStyle}>
      {/* NOTIFIKASI */}
      <div style={toastStyle}>
        {notification.type === "success" ? (
          <CheckCircle size={20} color="#22c55e" />
        ) : (
          <XCircle size={20} color="#ef4444" />
        )}
        <span style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>
          {notification.message}
        </span>
      </div>

      <Link
        to="/"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          textDecoration: "none",
          color: "#64748b",
          marginBottom: "20px",
        }}
      >
        <ArrowLeft size={18} /> Kembali
      </Link>

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "25px",
          background: "white",
          padding: "5px",
          borderRadius: "10px",
        }}
      >
        <button
          onClick={() => setActiveTab("bank")}
          style={tabBtnStyle(activeTab === "bank")}
        >
          🏦 Bank Soal
        </button>
        <button
          onClick={() => setActiveTab("assign")}
          style={tabBtnStyle(activeTab === "assign")}
        >
          📤 Tugaskan Siswa
        </button>
      </div>

      {/* --- TAB 1: BANK SOAL (CRUD) --- */}
      {activeTab === "bank" && (
        <>
          <div
            style={{
              background: "white",
              padding: "25px",
              borderRadius: "16px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
              marginBottom: "25px",
            }}
          >
            <h3
              style={{
                marginTop: 0,
                color: "#1e293b",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              {isEditing ? <Edit3 size={20} /> : <Plus size={20} />}{" "}
              {isEditing ? "Edit Kuis" : "Buat Kuis Baru"}
            </h3>
            <form onSubmit={handleSimpanKuis}>
              <div style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontWeight: "bold",
                    fontSize: "12px",
                    color: "#64748b",
                  }}
                >
                  JUDUL KUIS
                </label>
                <input
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                  }}
                  placeholder="Contoh: Kuis Harian Matematika Bab 1"
                  value={formKuis.judul}
                  onChange={(e) =>
                    setFormKuis({ ...formKuis, judul: e.target.value })
                  }
                />
              </div>
              <div
                style={{ display: "flex", gap: "15px", marginBottom: "15px" }}
              >
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "12px",
                      color: "#64748b",
                    }}
                  >
                    MATA PELAJARAN
                  </label>
                  <select
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "8px",
                      border: "1px solid #cbd5e1",
                    }}
                    value={formKuis.mapel}
                    onChange={(e) =>
                      setFormKuis({ ...formKuis, mapel: e.target.value })
                    }
                  >
                    <option value="">-- Pilih Mapel --</option>
                    {mapelList.map((m) => (
                      <option key={m.id} value={m.nama_mapel}>
                        {m.nama_mapel}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ flex: 2 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "12px",
                      color: "#64748b",
                    }}
                  >
                    LINK GOOGLE FORM / QUIZIZZ
                  </label>
                  <input
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "8px",
                      border: "1px solid #cbd5e1",
                    }}
                    placeholder="https://..."
                    value={formKuis.link_url}
                    onChange={(e) =>
                      setFormKuis({ ...formKuis, link_url: e.target.value })
                    }
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button
                  type="submit"
                  style={{
                    flex: 1,
                    background: "#2563eb",
                    color: "white",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "none",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  {isEditing ? "Update Kuis" : "Simpan Kuis"}
                </button>
                {isEditing && (
                  <button
                    type="button"
                    onClick={() => {
                      setIsEditing(false);
                      setFormKuis({
                        judul: "",
                        link_url: "",
                        mapel: "",
                        pembuat: "",
                      });
                    }}
                    style={{
                      background: "#94a3b8",
                      color: "white",
                      padding: "12px",
                      borderRadius: "8px",
                      border: "none",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Batal
                  </button>
                )}
              </div>
            </form>
          </div>

          <h3 style={{ color: "#334155" }}>Daftar Kuis ({kuisList.length})</h3>
          <div style={{ display: "grid", gap: "15px" }}>
            {kuisList.map((item) => (
              <div
                key={item.id}
                style={{
                  background: "white",
                  padding: "15px",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "bold",
                      color: "#1e293b",
                      fontSize: "16px",
                    }}
                  >
                    {item.judul}
                  </div>
                  <div style={{ fontSize: "13px", color: "#64748b" }}>
                    {item.mapel} •{" "}
                    <a
                      href={item.link_url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#2563eb" }}
                    >
                      Cek Link
                    </a>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 5 }}>
                  <button
                    onClick={() => handleEditKuis(item)}
                    style={{
                      background: "#fef3c7",
                      color: "#d97706",
                      border: "none",
                      padding: "8px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <Edit3 size={18} />
                  </button>
                  <button
                    onClick={() => handleDeleteKuis(item.id)}
                    style={{
                      background: "#fff1f2",
                      color: "#be123c",
                      border: "none",
                      padding: "8px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* --- TAB 2: TUGASKAN KUIS (ASSIGN) --- */}
      {activeTab === "assign" && (
        <div
          style={{
            background: "white",
            padding: "25px",
            borderRadius: "16px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          }}
        >
          <h3
            style={{
              marginTop: 0,
              color: "#1e293b",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Send size={20} color="#2563eb" /> Kirim Kuis ke Siswa
          </h3>

          <div
            style={{
              background: "#eff6ff",
              padding: "15px",
              borderRadius: "8px",
              marginBottom: "20px",
              fontSize: "13px",
              color: "#1e40af",
              display: "flex",
              gap: 10,
              alignItems: "start",
            }}
          >
            <Info size={18} style={{ flexShrink: 0, marginTop: 2 }} />
            <div>
              <strong>Filter Siswa:</strong> <br />
              {currentUser?.role === "tutor"
                ? `Menampilkan ${siswaList.length} siswa yang terdaftar sebagai murid Anda.`
                : "Menampilkan semua siswa (Mode Admin)."}
            </div>
          </div>

          <form onSubmit={handleAssign}>
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                  fontSize: "12px",
                  color: "#64748b",
                }}
              >
                PILIH KUIS
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                }}
                value={assignData.kuis_id}
                onChange={(e) =>
                  setAssignData({ ...assignData, kuis_id: e.target.value })
                }
              >
                <option value="">-- Pilih Soal Kuis --</option>
                {kuisList.map((k) => (
                  <option key={k.id} value={k.id}>
                    {k.judul} ({k.mapel})
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                  fontSize: "12px",
                  color: "#64748b",
                }}
              >
                PILIH SISWA
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                  background: siswaList.length === 0 ? "#f1f5f9" : "white",
                }}
                value={assignData.siswa_id}
                onChange={(e) =>
                  setAssignData({ ...assignData, siswa_id: e.target.value })
                }
                disabled={siswaList.length === 0}
              >
                <option value="">-- Pilih Siswa --</option>
                {siswaList.length === 0 && (
                  <option disabled>Tidak ada siswa ditemukan.</option>
                )}
                {siswaList.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.nama_lengkap} (Kelas {s.kelas})
                  </option>
                ))}
              </select>
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                background: "#16a34a",
                color: "white",
                padding: "14px",
                borderRadius: "8px",
                border: "none",
                fontWeight: "bold",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <Send size={18} /> Kirim Sekarang
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
